






































































































// TO DO: REPLACE WITH QUASAR COMPONENT
import Vue from 'vue'
import LocationIcon from '@/assets/svgs/location_icon.svg?inline'
import SearchIcon from '@/assets/svgs/search_icon.svg?inline'
import DropdownArrow from '@/assets/svgs/dropdown_arrow.svg?inline'
import ErrorIcon from '@/assets/svgs/circled_informational_icon.svg?inline'
interface ListItem {
  id: number
  name: string
}
interface Data {
  isFocused: boolean
  open: boolean
  value: string
  error: boolean
  focus: number | null
  previousValue: string
  defaultNumResultsShown: number
  firstListExpanderFlag: number
  secondListExpanderFlag: number
  thirdListExpanderFlag: number
  showMoreFromFirstList: boolean
  showMoreFromSecondList: boolean
  showMoreFromThirdList: boolean
}
interface Props {
  id?: string
  firstList: ListItem[]
  secondList: ListItem[] | null
  thirdList: ListItem[] | null
  inputName: string
  tabindex: number
  placeholder: string
  hasError: boolean
  startingValue: string
  iconType: string
  firstListHeader: string
  secondListHeader: string
  thirdListHeader: string
  hasExpanders: boolean
  rules?: (() => boolean)[]
  required: boolean
}
interface Methods {
  resetKeyboardValues: () => void
  detectKey: (event: KeyboardEvent) => void
}
interface Computed {
  firstListFiltered: ListItem[]
  secondListFiltered: ListItem[] | null
  thirdListFiltered: ListItem[] | null
}
export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'TypeToFilterDropdown',
  props: {
    id: {
      type: String,
      required: false
    },
    firstList: {
      type: Array,
      required: true
    },
    secondList: {
      type: Array,
      required: false
    },
    thirdList: {
      type: Array,
      required: false
    },
    inputName: {
      type: String,
      required: false,
      default: ''
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    },
    placeholder: String,
    hasError: Boolean,
    startingValue: String,
    iconType: String,
    firstListHeader: String,
    secondListHeader: String,
    thirdListHeader: String,
    hasExpanders: Boolean,
    rules: Array,
    required: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  components: {
    LocationIcon,
    DropdownArrow,
    SearchIcon,
    ErrorIcon
  },
  watch: {
    startingValue: function (newVal) {
      this.value = newVal
    },
    hasError: function (newVal) {
      this.$emit('error', this.$refs.input)
      this.error = newVal
    }
  },
  data: function () {
    return {
      isFocused: false,
      open: false,
      value: this.startingValue || '',
      error: this.hasError,
      focus: null,
      previousValue: '',
      defaultNumResultsShown: 3,
      firstListExpanderFlag: -1,
      secondListExpanderFlag: -2,
      thirdListExpanderFlag: -3,
      showMoreFromFirstList: false,
      showMoreFromSecondList: false,
      showMoreFromThirdList: false
    }
  },
  methods: {
    resetKeyboardValues: function () {
      this.open = false
      this.focus = null
      this.showMoreFromFirstList = false
      this.showMoreFromSecondList = false
      this.showMoreFromThirdList = false
    },
    detectKey (event: KeyboardEvent) {
      let lengthFirstList = this.firstListFiltered.length
      let lengthOfListItems = lengthFirstList
      let lengthSecondList
      let lengthThirdList
      let indexOfLastItemInFirstList = lengthFirstList - 1
      let indexOfLastItemInSecondList
      let indexOfLastItemInThirdList
      let indexOfLastShownResult
      let areItemsFromFirstListHidden
      let areItemsFromSecondListHidden
      let areItemsFromThirdListHidden
      let isFirstListLongerThanDefault
      let isSecondListLongerThanDefault
      let isThirdListLongerThanDefault
      let hasSecondList = this.secondListFiltered !== null
      let hasThirdList = this.thirdListFiltered !== null
      if (hasSecondList) {
        lengthSecondList = this.secondListFiltered?.length
        indexOfLastItemInSecondList = lengthFirstList + lengthSecondList - 1
        lengthOfListItems += lengthSecondList
      }
      if (hasThirdList) {
        lengthThirdList = this.thirdListFiltered?.length
        indexOfLastItemInThirdList = lengthFirstList + lengthSecondList + lengthThirdList - 1
        lengthOfListItems += lengthThirdList
      }
      if (this.hasExpanders) {
        indexOfLastShownResult = this.defaultNumResultsShown - 1
        isFirstListLongerThanDefault = lengthFirstList > this.defaultNumResultsShown
        areItemsFromFirstListHidden = isFirstListLongerThanDefault && !this.showMoreFromFirstList
        if (hasSecondList) {
          isSecondListLongerThanDefault = lengthSecondList > this.defaultNumResultsShown
          areItemsFromSecondListHidden = isSecondListLongerThanDefault && !this.showMoreFromSecondList
        }
        if (hasThirdList) {
          isThirdListLongerThanDefault = lengthThirdList > this.defaultNumResultsShown
          areItemsFromThirdListHidden = isThirdListLongerThanDefault && !this.showMoreFromThirdList
        }
      }
      switch (event.keyCode) {
        case 27: // escape
          this.resetKeyboardValues()
          this.value = this.previousValue
          break
        case 38: // arrow up
          if (this.focus === null) {
            this.focus = 0
            // Focus on the more/less expander for the first list
          } else if (this.hasExpanders && (areItemsFromFirstListHidden || this.showMoreFromFirstList) && this.focus === lengthFirstList) {
            this.focus = this.firstListExpanderFlag
            // Focus on the more/less expander for the second list
          } else if (this.hasExpanders && hasSecondList && (areItemsFromSecondListHidden || this.showMoreFromSecondList) && this.focus === lengthFirstList + lengthSecondList) {
            this.focus = this.secondListExpanderFlag
            // Focus on the more/less expander for the third list
          } else if (this.hasExpanders && hasThirdList && (areItemsFromThirdListHidden || this.showMoreFromThirdList) && this.focus === lengthFirstList + lengthSecondList + lengthThirdList) {
            this.focus = this.thirdListExpanderFlag
            // Skip hidden items from first list if closed
          } else if (this.focus === this.firstListExpanderFlag && areItemsFromFirstListHidden) {
            this.focus = indexOfLastShownResult
            // Don't skip first list if open
          } else if (this.focus === this.firstListExpanderFlag && !areItemsFromFirstListHidden) {
            this.focus = indexOfLastItemInFirstList
            // Skip hidden items from second list if closed
          } else if (this.focus === this.secondListExpanderFlag && areItemsFromSecondListHidden) {
            this.focus = lengthFirstList + indexOfLastShownResult
            // Don't skip second list if open
          } else if (this.focus === this.secondListExpanderFlag && !areItemsFromSecondListHidden) {
            this.focus = indexOfLastItemInSecondList
            // Skip hidden items from third list if closed
          } else if (this.focus === this.thirdListExpanderFlag && areItemsFromThirdListHidden) {
            this.focus = lengthFirstList + lengthSecondList + indexOfLastShownResult
            // Don't skip third if open
          } else if (this.focus === this.thirdListExpanderFlag && !areItemsFromThirdListHidden) {
            this.focus = indexOfLastItemInThirdList
            // default - decrement index by 1
          } else if (this.focus > 0) {
            this.focus--
          }
          break
        case 40: // arrow down
          if (this.focus === null) {
            this.focus = 0
            // Skip hidden items from first list if closed
          } else if (this.hasExpanders && this.focus === indexOfLastShownResult && areItemsFromFirstListHidden) {
            this.focus = this.firstListExpanderFlag
            // Skip hidden items from second list if closed
          } else if (this.hasExpanders && hasSecondList && this.focus === lengthFirstList + indexOfLastShownResult && areItemsFromSecondListHidden) {
            this.focus = this.secondListExpanderFlag
            // Skip hidden items from third list if closed
          } else if (this.hasExpanders && hasThirdList && this.focus === lengthFirstList + lengthSecondList + indexOfLastShownResult && areItemsFromThirdListHidden) {
            this.focus = this.thirdListExpanderFlag
            // Set a flag so the user can choose to see more or less values from the first list
          } else if (this.focus === indexOfLastItemInFirstList && this.showMoreFromFirstList) {
            this.focus = this.firstListExpanderFlag
          } else if (this.focus === this.firstListExpanderFlag) {
            this.focus = lengthFirstList
            // Set a flag so the user can choose to see more or less values from the second list
          } else if (this.focus === indexOfLastItemInSecondList && this.showMoreFromSecondList) {
            this.focus = this.secondListExpanderFlag
          } else if (this.focus === this.secondListExpanderFlag) {
            this.focus = lengthFirstList + lengthSecondList
            // Set a flag so the user can choose to see more or less values from the third list
          } else if (this.focus === indexOfLastItemInThirdList && this.showMoreFromThirdList) {
            this.focus = this.thirdListExpanderFlag
          } else if (this.focus === this.thirdListExpanderFlag) {
            this.focus = lengthFirstList + lengthSecondList + lengthThirdList
            // default - increment index by 1
          } else if (this.focus < lengthOfListItems) {
            this.focus++
          }
          break
        case 13: // enter
          event.preventDefault()
          // Show more values from the first list
          if (this.hasExpanders && this.focus === this.defaultNumResultsShown && areItemsFromFirstListHidden) {
            this.showMoreFromFirstList = !this.showMoreFromFirstList
          // Show more values from the second list
          } else if (this.hasExpanders && hasSecondList && this.focus === lengthFirstList + this.defaultNumResultsShown && areItemsFromSecondListHidden) {
            this.showMoreFromSecondList = !this.showMoreFromSecondList
          // Show more values from the third list
          } else if (this.hasExpanders && hasThirdList && this.focus === lengthFirstList + lengthSecondList + this.defaultNumResultsShown && areItemsFromThirdListHidden) {
            this.showMoreFromThirdList = !this.showMoreFromThirdList
          // Toggle first list expander
          } else if (this.focus === this.firstListExpanderFlag) {
            this.showMoreFromFirstList = !this.showMoreFromFirstList
          // Toggle second list expander
          } else if (this.focus === this.secondListExpanderFlag) {
            this.showMoreFromSecondList = !this.showMoreFromSecondList
          // Toggle third list expander
          } else if (this.focus === this.thirdListExpanderFlag) {
            this.showMoreFromThirdList = !this.showMoreFromThirdList
          } else if (this.focus !== null) {
            let list = ''
            if (this.focus <= indexOfLastItemInFirstList) {
              this.value = this.firstListFiltered[this.focus].name
              list = 'firstList'
            } else if (this.secondListFiltered !== null && this.focus <= indexOfLastItemInSecondList) {
              this.value = this.secondListFiltered[this.focus - lengthFirstList].name
              list = 'secondList'
            } else if (this.thirdListFiltered !== null && this.focus <= indexOfLastItemInThirdList) {
              this.value = this.thirdListFiltered[this.focus - lengthFirstList - lengthSecondList].name
              list = 'thirdList'
            }
            this.previousValue = this.value
            this.$emit('selected', this.value, list)
            this.resetKeyboardValues()
          }
      }
    }
  },
  computed: {
    firstListFiltered () {
      return this.firstList?.filter(
        (option) => option.name.toLowerCase().includes(this.value.toLowerCase())
      )
    },
    secondListFiltered () {
      if (this.secondList) {
        return this.secondList.filter(
          (option) => option.name.toLowerCase().includes(this.value.toLowerCase())
        )
      }
      return null
    },
    thirdListFiltered () {
      if (this.thirdList) {
        return this.thirdList.filter(
          (option) => option.name.toLowerCase().includes(this.value.toLowerCase())
        )
      }
      return null
    }
  }
})
